import { render, staticRenderFns } from "./Pricing-Table.vue?vue&type=template&id=82adaf9a&"
import script from "./Pricing-Table.vue?vue&type=script&lang=js&"
export * from "./Pricing-Table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports